import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNightlight = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19.3087 13.1735C19.6859 12.9964 20.0882 13.3677 19.983 13.7711C19.6242 15.1447 18.919 16.4519 17.8334 17.5375C14.6094 20.7611 9.45186 20.8285 6.31137 17.6883C3.17088 14.5482 3.23945 9.38999 6.46337 6.16641C7.54905 5.08084 8.8553 4.37579 10.2301 4.01698C10.6335 3.91186 11.0038 4.31409 10.8278 4.69118C9.68271 7.13543 10.0587 10.063 11.9981 12.0022C13.9363 13.9425 16.8642 14.3185 19.3087 13.1735V13.1735Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgNightlight);
export default ForwardRef;
